import React from 'react';
import { Tab } from 'semantic-ui-react';
import AigcBillContent from './AigcBillContent';
import ApiBill from './ApiBill';

const AigcBill = () => {
  const panes = [
    {
      menuItem: 'API 账单',
      render: () => (
        <Tab.Pane attached={false}>
          <ApiBill />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'AIGC 账单',
      render: () => (
        <Tab.Pane attached={false}>
          <AigcBillContent />
        </Tab.Pane>
      ),
    },
  ];

  return <Tab panes={panes} defaultActiveIndex={0} />;
};

export default AigcBill;
